var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4365 12.8038C22.4365 7.24719 17.9594 2.74268 12.4365 2.74268C6.91367 2.74268 2.43652 7.24719 2.43652 12.8038C2.43652 17.8255 6.09336 21.9879 10.874 22.7427V15.7121H8.33496V12.8038H10.874V10.5872C10.874 8.06564 12.367 6.6728 14.6511 6.6728C15.7453 6.6728 16.8896 6.86931 16.8896 6.86931V9.34529H15.6287C14.3865 9.34529 13.999 10.1209 13.999 10.9166V12.8038H16.7724L16.3291 15.7121H13.999V22.7427C18.7797 21.9879 22.4365 17.8257 22.4365 12.8038Z",
    fill: "#4753EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.f478558e67177aaa377467ac1809e72f.svg";
export { ForwardRef as ReactComponent };